import { cn } from "helper/Utils";
import React from "react";

const MobileFilters = ({ isOpen, onClickToggle, selectedFilters, children }) => {
  return (
    <div className="p-3 bg-white/10 rounded">
      <button className={cn("md:hidden w-full flex justify-between ")} onClick={onClickToggle}>
        <div className="flex gap-4 justify-between items-center">
          <i className="bc-i-filter text-sm" />
          <div className="flex flex-col items-start text-sm">
            <small className="leading-none">Filter</small>
            {!isOpen && (
              <span className="text-white/60 leading-none mt-1">
                {selectedFilters && Object.entries(selectedFilters).length > 0
                  ? Object.entries(selectedFilters)
                      .map(([key, item]) => {
                        if (item && typeof item === "object" && "label" in item) {
                          return item.label;
                        }
                        return item;
                      })
                      .filter(Boolean)
                      .join(", ")
                  : null}
              </span>
            )}
          </div>
        </div>
        <i className={cn("text-[12px]", isOpen ? "bc-i-small-arrow-up pt-1" : "bc-i-small-arrow-down pt-1.5 pr-1")} />
      </button>
      <div className={cn("", isOpen ? "block" : "hidden")}>
        <hr className="border-black my-4" />
        {children}
      </div>
    </div>
  );
};

export default MobileFilters;
